import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { useNavigate } from "react-router-dom";
import ApiClient from "../ApiClient";
import { getRequestGlobal } from "../../../API/global";

const CardCmot = ({ handlePrint, impoData }) => {
  const { getRequest, postRequest } = ApiClient();
  const [preData, setPredata] = useState([]);
  const [language, setLanguage] = useState({});
  const navigate = useNavigate();
  const [oldYearData, setOldYearData] = useState([]);
  const [showAddNewEntryCmot, setShowAddNewEntryCmot] = useState(false); // New state for activeTab === 2

  const [craftData, setCraftData] = useState([]);

  useEffect(() => {
    loadCraft();
    fetchData();
  }, []);

  const loadCraft = async () => {
    let data = {};
    const predata = await getRequest(`craft`, {});
    if (predata.status && predata.data.length) {
      for (const craft of predata.data) {
        data[craft.id] = craft.name;
      }
      setCraftData(data);
    }
  };
  const fetchData = async () => {
    try {
      const preData = await getRequest("cmot");
      const data = preData.data;
      setPredata(data);
      const olddata = preData?.oldlistdata || [];
      console.log("CMOT old Data", olddata);
      setOldYearData(olddata);
      // if (data && data.length <= 1) setShowAddNewEntryCmot(true);
      // console.log('Data:', data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    getRequestGlobal("language_list", {})
      .then((data) => {
        // console.log(data, "language data ott");
        setLanguage(data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }, []);

  const handleEditClick = (id) => {
    navigate(`/cmot/${id}`);
  };

  const handleViewClick = (id) => {
    navigate(`/cmot/view/${id}`);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (confirmDelete) {
      try {
        const data = await postRequest(`cmot/delete/${id}`);
        if (data.status) {
          window.location.reload();
        }
        // setPredata(preData.filter((item) => item.id !== id));
      } catch (error) {
        console.error("Delete error:", error);
      }
    }
  };

  // const addNewEntryCmot = () => {
  //     if (showAddNewEntryCmot) {
  //         navigate("/cmot"); // Assuming '/Cmot' is the correct route
  //     } else {
  //         alert("You have reached the maximum limit.");
  //     }
  // }

  const [cmotClosed, setCmotClosed] = useState();

  useEffect(() => {
    if (impoData?.cmot) {
      const CMOT = impoData.cmot.close;
      console.log(CMOT);
      setCmotClosed(CMOT);
    }
  }, [impoData]);

  return (
    <>
      {preData.length === 0 ? (
        <></>
        // <div className="text-center">
        //   <p className="no-content">
        //     {" "}
        //     <h4>
        //       You haven't added any entries yet. To get started, simply click on{" "}
        //       <Button
        //         sx={{ color: "inherit" }}
        //         // variant="contained"
        //         onClick={() => navigate("/cmot")}
        //         style={{ backgroundColor: "#1c5768", color: "#fff" }}
        //       >
        //         Add New Entry
        //       </Button>
        //     </h4>
        //   </p>
        // </div>
      ) : (
        <div className="card-container">
          <>
            {preData.map((item) => (
              <div className="card_con" key={item.id}>
                <h1 className="title mb-4">{item.name}</h1>

                <ul className="listView">
                  {craftData[item.category_id] ? (
                    <>
                      <li>
                        <h5>Film Craft</h5>{" "}
                        <h6>{craftData[item.category_id]}</h6>
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <h5>DOB</h5> <h6>{item.dob}</h6>
                      </li>
                    </>
                  )}
                  {item.submission_date_and_time ? (
                    <>
                      <li>
                        <h5>Submission Date & Time</h5>
                        <h6>{item.submission_date_and_time}</h6>
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <h5>Number</h5> <h6>{item.contact_number}</h6>
                      </li>
                    </>
                  )}
                </ul>
                <div className="button_con">
                  {item.step >= 5 ? (
                    <Button
                      style={{ color: "#fff" }}
                      onClick={() => handleViewClick(item.id)}
                    >
                      View
                    </Button>
                  ) : (
                    <>
                      {/* {cmotClosed === 1 ? ( */}
                      {1 === 1 ? (
                        <>
                          <Button
                            variant="contained"
                            onClick={() => handleEditClick(item.id)}
                          >
                            <EditIcon />
                            Edit
                          </Button>
                          <Button
                            className="del_btn"
                            variant="contained"
                            onClick={() => handleDelete(item.id)}
                            startIcon={<DeleteIcon sx={{ color: "#f67474" }} />}
                          >
                            Delete
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </>
        </div>
      )}
      {!Object.keys(oldYearData).length ? (
        <div className="card_con mt-4">
          <Typography variant="body1">
            No previous submissions available.
          </Typography>
        </div>
      ) : (
        Object.entries(oldYearData)
          .sort((a, b) => Number(b[0]) - Number(a[0])) // Sort years descending (latest first)
          .map(([year, items]) => (
            <Accordion sx={{ mt: 2 }} key={year} className="accordian_class">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel-${year}-content`}
                id={`panel-${year}-header`}
              >
                <Typography variant="h6" component="span">
                  Your Previous Submissions - {year}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="card-container">
                  {items.map((item) => (
                    <div className="card_con" key={item.id}>
                      <h1 className="title mb-4">{item.name}</h1>

                      <ul className="listView">
                        <li>
                          <h5>Film Craft</h5>{" "}
                          <h6>{craftData[item.category_id]}</h6>
                        </li>
                        {item.submission_date_and_time ? (
                          <>
                            <li>
                              <h5>Submission Date & Time</h5>
                              <h6>{item.submission_date_and_time}</h6>
                            </li>
                          </>
                        ) : (
                          <></>
                        )}
                      </ul>
                    </div>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          ))
      )}
    </>
  );
};

export default CardCmot;
